import { ControlContainer } from '@angular/forms';
import { HostBinding, Directive, Input, Optional } from '@angular/core';

@Directive({
    selector: 'label[controlName]',
    standalone: false
})
  export class LabelControl {
    @Input() controlName: string;
  
    constructor(@Optional() private parent: ControlContainer) {}
  
    @HostBinding('textContent')
    get controlValue() {
      return this.parent ? this.parent.control.get(this.controlName).value : '';
    }
  }